export default class MatchOddsMarketTypeModel {
  public id: string = null;
  public name: string = null;
  public code: string = null;
  public entityType: string = null;
}
